import React from "react";
import "./StringInput.css";
import InputX from "./InputX";
import { Input } from "antd";

const StringInput = ({
  id,
  title,
  value,
  onValueChange,
  width = "180px",
  disabled = false,
  hideX = false,
  ...props
}) => {
  return (
    <div className={"string-input-wrapper tw-px-1"}>
      <div className={"string-input-title"}>{title}</div>
      <Input
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onValueChange(e.target.value)}
        allowClear
      />
    </div>
  );
};

export default StringInput;
